import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_ALARM } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import AlarmLogs from '../../components/Alarms/AlarmLogs';

// Optional pre-filter: opened from the alarm list row actions with ?alarm-id=<id>
const alarmLogSearchSchema = z.object({
  'alarm-id': z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/alarm/log')({
  validateSearch: alarmLogSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_ALARM, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.alarm/log',
        suffix: 'menu.alarms',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AlarmLogsRoute,
});

function AlarmLogsRoute() {
  return <AlarmLogs />;
}
